import { FC, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const MobileMapPageRedirect: FC = () => {
    const { search } = useLocation();
    const navigate = useNavigate();

    const getSpeciesName = (speciesId: string) => {
        switch(speciesId) {
            case "6":
                return "wilddogscan";
            case "10":
                return "deerscan";
            case "1":
                return "rabbitscan";
            case "15":
                return "feralcatscan";
            case "2":
                return "foxscan";
            case "4":
                return "feralpigscan";
            case "5":
                return "mynascan";
            case "7":
                return "toadscan";
            case "12":
                return "mousealert";
            case "8":
                return "feralgoatscan";
            case "11":
                return "feralfishscan";
            case "9":
                return "starlingscan";
            case "18":
                return "otherpests";
            case "17":
                return "newpests";
            default:
                return "";
        }
    }

    useEffect(() => {
        const params = new URLSearchParams(search);

        const species = params.get("species");

        if (!species) {
            navigate("/error/404", { replace: true });
            return;
        }

        navigate(`/${getSpeciesName(species)}/map`);

    }, [search, navigate]);

    return null;
};

export default MobileMapPageRedirect;
